module.exports = __webpack_public_path__ + "/images/cdiscount-logo.c020bd1.svg";